export const zIndex = {
  alertBanner: 20,
  datePicker: 2000,
} as const
